import Header from './header';
import { useContext, useEffect } from 'react';
import Product from './product';
import NewItkSidebar from './sidebar';
import { CategoriesContext } from '../../../App';
import { TemplateProps } from '../index';
import './styles_old.scss';
import './styles.scss';
import Page from '../../page';
import NewItkHome from './home';
import NewItkSearch from './search';
import NewItkCategoryInner from './category-inner';
import NewItkCatalogWrapper from './catalog-wrapper';
import NewItkNotFound from './not-found';
import MobileMenu from './mobile-menu';

function NewItk({ hasPendingRequests }: TemplateProps) {
    const { isProduct, categories, fetchCategoryChildren } = useContext(CategoriesContext);
    useEffect(() => {
        /* В ITK катгеории какого-то хрена завернуты в лишний уровень */
        if (categories[0] && categories[0]?.children?.some((cat) => !cat.children)) {
            fetchCategoryChildren(categories[0].slugPath);
        }
    }, [categories, fetchCategoryChildren]);
    return (
        <>
            <section className={'new-itk-catalog container ' + (isProduct ? ' product-main' : '')}>
                <div className="preloader" style={{ display: hasPendingRequests ? 'block' : 'none' }}>
                    <span className="spinner" />
                </div>
                <MobileMenu />
                <Header />
                {isProduct ? (
                    <Product />
                ) : (
                    <section className="catalog">
                        <div className="catalog__container">
                            <NewItkSidebar />
                            <Page
                                home={NewItkHome}
                                search={NewItkSearch}
                                categoryOuter={NewItkCategoryInner}
                                categoryInner={NewItkCategoryInner}
                                catalog={NewItkCatalogWrapper}
                                notFound={NewItkNotFound}
                            />
                        </div>
                    </section>
                )}
            </section>
        </>
    );
}

export default NewItk;
